import React from 'react'

import { OrdersContext } from 'contexts/OrdersContext'
import { MapIcon, XIcon } from 'lucide-react'
import {
  DcButton,
  DcDropDown,
  PixelCheckboxGroup,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'
import { get, put } from 'utils/api-routes.util'
import {
  IPixelFactory,
  IWarehouse,
  WarehousePickup,
} from '../../../../../../decl.d'
interface IProps {
  warehouse: IWarehouse
  handleClose: (data: WarehousePickup) => void
}
const MapCourier = (props: IProps) => {
  const { warehouse, handleClose } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [pickupAddress, setPickupAddress] = React.useState([])
  const { state } = React.useContext(OrdersContext)
  const [data, setData] = React.useState({
    source_pickup_id: '',
    courier_id: '',
    warehouse_id: warehouse.id,
  })
  React.useEffect(() => {
    setData({
      ...data,
      warehouse_id: warehouse.id,
    })
  }, [warehouse])
  const [meta, setMeta] = React.useState({
    couriers: [],
  })

  React.useEffect(() => {
    setMeta({
      ...meta,
      couriers: state.couriers,
    })
  }, [state])
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    put('/courier/pickup-address/warehouse-mapping', data).subscribe(
      (res: AjaxResponse<IResponse | any>) => {
        hidePageLoader()
        const responseData = res.response
        if (responseData.data) {
          showSuccess(responseData.message)
          handleClose(responseData.data)
        } else if (responseData.error && responseData.field) {
          setError({
            error: responseData.error,
            filed: responseData.field,
          })
        } else {
          showFailure(responseData.error)
        }
      },
    )
  }
  const handleCourierChange = (selectedCourierId) => {
    get(`/courier/pickup-address/${selectedCourierId}`).subscribe((res) => {
      if (res?.response?.data) {
        setPickupAddress(res?.response?.data)
      }
    })
  }
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexWrap="wrap"
          gap="10px"
          width="100%"
          style={{ flexGrow: '1' }}
          flexDirection="row"
        >
          <DcDropDown
            required
            error={
              error.field === 'Select Courier' && error.error !== ''
                ? error.error
                : null
            }
            placeholder="Courier"
            options={[...meta.couriers].map((item) => {
              return {
                label: item.courier_name,
                value: item.courier_id,
              }
            })}
            value={data.courier_id}
            onChange={(e) => {
              setData({
                ...data,
                courier_id: e.target.value,
              })

              handleCourierChange(e.target.value)
            }}
          />
          <strong style={{ width: '30%' }}>Warehouse Address:</strong>
          <PixelFlexBox padding="5px">
            <PixelText>{warehouse.address}</PixelText>
          </PixelFlexBox>
          {pickupAddress?.length ? (
            <>
              <strong>Courier Pickup Addresses:</strong>
              <PixelFlexBox padding="10px">
                <PixelCheckboxGroup
                  required
                  direction="column"
                  options={pickupAddress?.map((address, index) => ({
                    label: (
                      <PixelDiv key={index}>
                        <PixelDiv>{address.city}</PixelDiv>
                        <PixelDiv>{address.address}</PixelDiv>
                        <PixelDiv>
                          Source Pickup ID: {address.source_pickup_id}
                        </PixelDiv>
                        {address.warehouse != null && (
                          <PixelText customColour={'red'}>
                            Already Mapped
                          </PixelText>
                        )}
                      </PixelDiv>
                    ),
                    value: address.source_pickup_id,
                    type: 'radio',
                    disabled: address.warehouse != null,
                    checked: address.source_pickup_id == data.source_pickup_id,
                  }))}
                  onChange={(e) => {
                    setData({
                      ...data,
                      source_pickup_id: e.target.value,
                    })
                  }}
                />
              </PixelFlexBox>
            </>
          ) : (
            <PixelText>
              {'No Courier Record, Please Select a Courier'}
            </PixelText>
          )}
        </PixelFlexBox>
        <PixelFlexBox
          flexWrap="wrap"
          justifyContent="flex-end"
          gap="10px"
          width="100%"
          flexDirection="row"
          flexEnd
        >
          <DcButton
            variant="outline-secondary"
            onClick={handleClose}
            size="sm"
            withIcon={true}
          >
            <XIcon size={16} />
            <span>Close</span>
          </DcButton>
          <DcButton type={'submit'} size="sm" withIcon={true}>
            <MapIcon size={16} />
            <span>Map</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}
export default MapCourier
